import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
import TableResponsiveLoading from "@/components/loading/TableResponsiveLoading.vue";
import { v4 as uuidv4 } from "uuid";

// props
interface IProps {
	data: any;
	disableMobile?:boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TableResponsive',
  props: {
    data: null,
    disableMobile: { type: Boolean }
  },
  setup(__props: any) {



// computed
const isMobile = computed<boolean>(() => currentWidth.value < 768);

// data
const uuid = ref<string>(uuidv4());
const currentWidth = ref<number>(window.innerWidth);

// methods
function startListenResize() {
	window.addEventListener("resize", () => {
		currentWidth.value = window.innerWidth;
	});
}

// setup
onMounted(startListenResize);

return { __sfc: true,isMobile, uuid, currentWidth, startListenResize, TableResponsiveLoading }
}

})